import React from "react";
import { Redirect } from "react-router";
import { AppRouteUi } from "../config/appRoute";
import { useAppSelector } from "../core/redux";

export function RedirectToLoginOnUnauthorized(
  props: React.PropsWithChildren<{}>
): JSX.Element {
  const isNotLoggedIn = useAppSelector((state) => !state.auth.isLoggedIn);

  if (isNotLoggedIn) return <Redirect to={AppRouteUi.Login.Root()} />;

  return <>{props.children ?? null}</>;
}
